import {Message} from 'epic-fortnite-react';
import React from 'react';

/**
 * Code Not Found component.  Shown when Code is not found.
 */
const CodeNotFound = () => {
  return (
    <div className="CodeNotFound errorPages">
      <div className="content">
        <div className="errorHeader">
          <h1>
            <Message code="epic.fortnite.common.sorry" />
          </h1>
        </div>
        <div className="errorBody">
          <p>
            <Message code="epic.creative-mode.codeNotFound" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default CodeNotFound;
